export const CAMPAIGN = "CAMPAIGN";
export const TEAM = "TEAM";
export const EMPLOYEE = "EMPLOYEE";
